/**
 * MessageViewHeader
 *
 * Header component for message views with actions
 */

export * from './MessageViewHeader';